import ReportProductDetailsContainer from './ReportProductDetails';
export default ReportProductDetailsContainer;
